module.exports = __webpack_public_path__ + "static/img/children.c524aaa.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/student/children.png
// module id = btaf
// module chunks = 1